import React, {createContext, useContext, useReducer} from 'react';

const SalesContext = createContext();

const initialState = {
  clickedItem: null, // Should be a GeoJSON Feature
};

function salesReducer(state, action) {
  switch (action.type) {
    case 'SET_CLICKED_ITEM':
      return {
        ...state,
        clickedItem: action.payload,
      };
    case 'CLEAR_CLICKED_ITEM':
      return {
        ...state,
        clickedItem: null,
      };
    default:
      return state;
  }
}

export function SalesProvider({children}) {
  const [state, dispatch] = useReducer(salesReducer, initialState);

  return (
    <SalesContext.Provider value={{state, dispatch}}>
      {children}
    </SalesContext.Provider>
  );
}

export function useSales() {
  const context = useContext(SalesContext);
  if (!context) {
    throw new Error('useSales must be used within a SalesProvider');
  }
  return context;
}
